import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { ErrorToaster } from "../components/toaster/Toaster";
import { generatePdf } from "../../utils/helper";
import { useSelector } from "react-redux";
import InvoiceServices from "../../services/Invoice";
import InvoiceFormatOne from "../components/InvoiceFormats/formate-one";
import InvoiceFormatTwo from "../components/InvoiceFormats/formate-Two";
import { useReactToPrint } from "react-to-print";

const InvoicePreview = () => {

  const invoiceRef = useRef(null);
  const { id } = useParams();
  const { userData } = useSelector((state) => {
    return {
      userData: state.user_detail
    }
  });

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Invoice Data
  const [invoice, setInvoice] = useState();

  // *For Generate PDF
  const handleGeneratePdf = useReactToPrint({
    contentRef: invoiceRef,
    documentTitle: `invoice_${invoice?.fbr_invoice_number}`,
    onBeforePrint: () => {
      setLoading(true);
      return Promise.resolve();
    },
    onAfterPrint: () => setLoading(false),
  });
  // const handleGeneratePdf = async () => {
  //   setLoading(true)
  //   try {
  //     if (userData?.id == 7) {
  //       const clone = invoiceRef.current.cloneNode(true);
  //       clone.style.transform = 'none';
  //       clone.style.transformOrigin = 'unset';
  //       clone.style.width = '1123px';

  //       clone.style.position = 'absolute';
  //       clone.style.left = '-9999px';
  //       document.body.appendChild(clone);

  //       await generatePdf(clone)
  //     } else {
  //       await generatePdf(invoiceRef.current)
  //     }
  //   } catch (error) {
  //     console.log('handleGeneratePdf => error:', error)
  //   } finally {
  //     setLoading(false)
  //   }
  // };

  // *For Get Invoice Details
  const getInvoiceDetails = async () => {
    try {
      const { data } = await InvoiceServices.getInvoiceById(id)
      setInvoice(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    if (id) {
      getInvoiceDetails()
    }
  }, [id]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header d-flex align-items-center justify-content-between">
          <div className="page-title">
            <h4>View Sale Invoice</h4>
          </div>
          <div className="d-flex align-items-center">
            <button disabled={loading} className="btn btn-added" onClick={() => handleGeneratePdf()}>
              <PlusCircle className="me-2 iconsize" />
              {loading ? 'Printing...' : 'Print'}
            </button>
          </div>
        </div>

        <div className="card-body mb-3" style={{ transform: 'scale(0.93)', transformOrigin: 'top left', }}>
          <div ref={invoiceRef} className="card m-auto" style={{ width: '1123px', minHeight: '700px', border: 'none', position: 'relative' }}>
            {userData?.id == 7 ? (
              <InvoiceFormatTwo invoice={invoice} />
            ) : (
              <InvoiceFormatOne companyName={userData?.name} invoice={invoice} logo={userData?.logo} />
            )}
            <div style={{ height: '80px' }}></div>
            <h4 className="text-center" style={{ fontSize: '16px', fontWeight: '300' }}>This is a system generated invoice and does not required any signature and stamp.</h4>
          </div>
        </div>

      </div>
    </div>
  );
};

export default InvoicePreview;
